// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3hfDX","ScrollX":"Scroll_ScrollX__11Fkk","ScrollY":"Scroll_ScrollY__3OAsn"};